import { ActivityState } from './types'

export const state: ActivityState = {
  activityContacts: null,
  activityTasks: null,
  activities: null
}
